module.exports = __webpack_public_path__ + "img/main_colored_logo.612bc4fa.png";